module.exports = __webpack_public_path__ + "img/zhongjin.12b6c180.png";